import axios from "axios";
import { baseUrl } from "../utils/config";
import { fetchWithAuthJson } from "../context/FetchWithAuth";

export const login = async (credentials: {email: string; password: string; grant_type: "password"}) => {
    const response = await axios.post(`${baseUrl}/app_api/v1/oauth/token`, credentials);
    return response.data;
}

export const getUserInfo = async (email: string) => {
    const token = localStorage.getItem("token");
    if(!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/getUser?email=${encodeURIComponent(email)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}`}
    });

    return response;
}

export const getVersionBack = async () => {
    const token = localStorage.getItem("token");
    if(!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/version`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}`}
    });

    return response;
}